import { useEffect, useState } from "react"
import { NeutralColors,Text } from "@fluentui/react"



interface IEstadoProperties{
    color:string,
    backGroundColor:string
    nombre:string
    border:string
}
interface IEstadoEquipoComponent{
    estado:string
}

export const EstadoEquipoComponent=(props:IEstadoEquipoComponent)=>{
  const [propiedad,setPropiedad]=useState<IEstadoProperties>({
    nombre:"",
    color:"",
    backGroundColor:"",border:""
  })
  useEffect(()=>{
    switch(props.estado){
        case "OPERATIVO":
        setPropiedad({nombre:"Operativo",color:'#00B050',backGroundColor:'#00B05033',border:'#00B050'})
        break;
        case "STAND BY":
        setPropiedad({nombre:"Stand By",color:'#18A6DE',backGroundColor:'#18A6DE33',border:'#18A6DE'})
        break;
        case "MALOGRADO":
        setPropiedad({nombre:"Malogrado",color:'#EE2724',backGroundColor:'#EE272433',border:'#EE2724'})
        break;
        case "DEMORA":
        setPropiedad({nombre:"Demora",color:'#F78F1E',backGroundColor:'#F78F1E33',border:'#F78F1E'})
        break;
    }
  },[props.estado])
  return(
    <div style={{border:`1px solid ${propiedad.border}`, fontSize:'10px', minWidth:'60px',minHeight:'20px' 
    ,alignItems:'center',display:'flex',justifyContent:'center',
    borderRadius: '30px',backgroundColor: `${propiedad.backGroundColor}`, color:`${propiedad.color}`,}}>

     {propiedad.nombre}
      
    </div>
  )
}